import { assetsUrl } from "../../../common/config";

export const wantToAchiveAnswerImages = new Map([
  [
    1,
    {
      url: `${assetsUrl}/onboarding/savingMoney.svg`,
      alt: "Fruition saving money",
    },
  ],
  [
    2,
    {
      url: `${assetsUrl}/onboarding/manageDebt.svg`,
      alt: "Fruition manage debt",
    },
  ],
  [
    3,
    {
      url: `${assetsUrl}/onboarding/buildWealth.svg`,
      alt: "Fruition build wealth debt",
    },
  ],
  [
    4,
    {
      url: `${assetsUrl}/onboarding/retirement.svg`,
      alt: "Fruition retirement",
    },
  ],
  [
    5,
    {
      url: `${assetsUrl}/onboarding/insurance.svg`,
      alt: "Fruition insurance",
    },
  ],
]);
